import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { isDefined } from '@shared/utils/is-defined.utils';
import { Observable } from 'rxjs';

import { SHOW_GLOBAL_LOADER } from '../../../../shared/data-access/data-access-ui';
import { CreateInviteRequest } from '../model/create-invite-request.model';
import { FilterInviteRequest } from '../model/filter-invite-request.model';
import { Invite } from '../model/invite.model';

@Injectable()
export class InviteService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  getInvites(payload: FilterInviteRequest): Observable<Invite[]> {
    let params = new HttpParams().set('organizationId', payload.organizationId);

    if (payload.search) {
      params = params.set('search', payload.search);
    }

    if (isDefined(payload.pageNumber)) {
      params = params.set('pageNumber', payload.pageNumber);
    }

    if (payload.pageSize) {
      params = params.set('pageSize', payload.pageSize);
    }

    return this.http.get<Invite[]>(`${this.baseUrl}/v1/invites`, {
      params,
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, payload.enableGlobalLoader),
    });
  }

  createInvite(payload: CreateInviteRequest): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/v1/invites`, payload);
  }

  deleteInvite(inviteId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/v1/invites/${inviteId}`, {
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
    });
  }
}
